import React from 'react';
import dayjs from 'dayjs';
import { Popconfirm, Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';

import styles from './Gateway.module.less';

const relativeTime = require('dayjs/plugin/relativeTime');

dayjs.extend(relativeTime);

const commonColumns = (t) => [
  {
    title: t('tables.gateway.columns.name'),
    width: '11%',
    dataIndex: 'name',
    fixed: 'left',
    sorter: true,
  },
  {
    title: t('forms.users.labels.business_line'),
    width: '11%',
    dataIndex: 'business_type_name',
    fixed: 'left',
    sorter: true,
  },
  {
    width: '11%',
    title: t('tables.gateway.columns.mac'),
    dataIndex: 'mac',
    render: (mac) => mac || '-',
  },
  {
    width: '11%',
    title: t('tables.gateway.columns.firmware'),
    dataIndex: 'firmware_name',
    render: (firmware_name) => firmware_name || '-',
  },
  {
    width: '11%',
    title: t('tables.gateway.columns.communication_interface'),
    dataIndex: 'hwInt',
    render: (hwInt) => hwInt || '-',
  },
  {
    title: t('tables.gateway.columns.baud_rate'),
    width: '11%',
    dataIndex: 'baud',
    render: (baud) => baud || '-',
  },
  {
    title: t('tables.gateway.columns.sampling_interval'),
    width: '11%',
    dataIndex: 'ival',
    render: (ival) => ival || '-',
  },
];

const columnsGateway = (t, deleteGateway, editGateway, currentUser) => {

  const isAdmin = currentUser.role === 'Superadmin' || currentUser.role === 'Admin';

  const columns = commonColumns(t);

  if (isAdmin) {

    columns.push(
      {
        key: 'has_missing_data_alarm_rule',
        width: '10%',
        title: '',
        dataIndex: 'id',
        render: (_, record) => ( // edit users
          // eslint-disable-next-line react/jsx-filename-extension
          <Space>
            <div className={styles.btnsIcon} style={{ marginRight: 5 }}>
              <FontAwesomeIcon icon={faEdit} onClick={() => editGateway(record)} />
            </div>

            <div className={styles.btnsIcon} style={{ marginLeft: 5 }}>
              <Popconfirm
                title={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_title')}
                okText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_ok')}
                cancelText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_cancel')}
                onConfirm={() => deleteGateway(record)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Popconfirm>
            </div>
          </Space>
        ),
      },

    );

}

  return columns;

};

export default columnsGateway;
